export const AO_PRODUCT_DETAILS_REQUEST = 'AO_PRODUCT_DETAILS_REQUEST';
export const AO_PRODUCT_DETAILS_SUCCESS = 'AO_PRODUCT_DETAILS_SUCCESS';
export const AO_PRODUCT_DETAILS_FAILURE = 'AO_PRODUCT_DETAILS_FAILURE';
export const AO_PRODUCT_DETAILS_RESET = 'AO_PRODUCT_DETAILS_RESET';
export const sendAddOrderProductDetailsSuccess = (payload) => ({
    type: AO_PRODUCT_DETAILS_SUCCESS,
    payload,
});
export const sendAddOrderProductDetailsRequest = (payload) => ({
    type: AO_PRODUCT_DETAILS_REQUEST,
    payload,
});
export const sendAddOrderProductDetailsFailure = (payload) => ({
    type: AO_PRODUCT_DETAILS_FAILURE,
    payload,
});
export const sendAddOrderProductDetailsReset = (payload) => ({
    type: AO_PRODUCT_DETAILS_RESET,
    payload,
});
